import React from 'react';
import styled from 'styled-components';
import { MEDICAL_QUESTIONS } from './healthProposalQuestion';
import { axiosPOSTCall1 } from '../../../utilities/utils/apiPost';

const Section = styled.div`
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin-top: 30px;
`;

const Title = styled.h2`
  background-color: #f28c28;
  color: white;
  padding: 12px 20px;
  margin: -20px -20px 20px;
  font-size: 18px;
`;

const SubTitle = styled.h3`
  color: #f28c28;
  margin-bottom: 20px;
`;

const QuestionBlock = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.label`
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
`;

const RadioGroup = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;

const ButtonSubmit = styled.button`
  margin-top: 10px;
  padding: 10px 25px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
`;

const ButtonBack = styled.button`
  margin-top: 10px;
  margin-right: 10px;
  padding: 10px 25px;
  background-color: rgb(240, 40, 40);
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
`;


const MedicalHistory = ({
  values = {},
  setValues,
  slug,
  onBack,
  onContinue,
  septateCombinedRedux,
}) => {
  const insuredMembers = septateCombinedRedux.insuredMembers || {};
  console.log("🚀 ~ septateCombinedRedux?.saveProposalResponse:", septateCombinedRedux)
  const questions = MEDICAL_QUESTIONS[slug] || [];

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   onContinue(e);


  //     handlePayment(e);
  // };


  const getDynamicKey = (memberKey, relation) => {
    if (memberKey === 'child' && relation) {
      return `proposalMedicalQuestion_${relation.toLowerCase()}`;
    }
    return memberKey;
  };
  const handleChange = (memberKey, index, question, member) => (e) => {
    if (memberKey === 'child') {
      const children = [...(insuredMembers.child || [])];
      const child = children[index];

      const updatedAnswers = (child.proposalMedicalQuestion || []).filter(
        (q) => q.key !== question.key
      );

      const newAnswer = { key: question.key, answer: e.target.value };

      children[index] = {
        ...child,
        proposalMedicalQuestion: [...updatedAnswers, newAnswer],
      };

      setValues((prev) => ({
        ...prev,
        insuredMembers: {
          ...insuredMembers,
          child: children,
        },
      }));
    } else {
      const prev = values?.proposalMedicalQuestion || {};
      const updatedAnswers = (prev[memberKey] || []).filter(
        (q) => q.key !== question.key
      );

      const newAnswer = { key: question.key, answer: e.target.value };

      setValues({
        ...values,
        proposalMedicalQuestion: {
          ...prev,
          [memberKey]: [...updatedAnswers, newAnswer],
        },
      });
    }
  };


  // const handleChange = (memberKey, index, question, relation) => (e) => {
  //   const prev = values?.proposalMedicalQuestion || {};
  //   const dynamicKey = getDynamicKey(memberKey, relation);
  //   const memberAnswers = prev[dynamicKey] || [];

  //   const updatedAnswers = memberAnswers.filter((q) => {
  //     if (memberKey === 'child') {
  //       return !(q.key === question.key && q.index === index);
  //     }
  //     return q.key !== question.key;
  //   });

  //   const newAnswer = {
  //     key: question.key,
  //     answer: e.target.value,
  //     ...(memberKey === 'child' ? { index } : {}),
  //   };

  //   setValues({
  //     ...values,
  //     proposalMedicalQuestion: {
  //       ...prev,
  //       [dynamicKey]: [...updatedAnswers, newAnswer],
  //     },
  //   });
  // };

// const getAnswer = (memberKey, index, key, relation) => {
//     const dynamicKey = getDynamicKey(memberKey, relation);
//     const memberAnswers = values?.proposalMedicalQuestion?.[dynamicKey] || [];

//     if (memberKey === 'child') {
//       return (
//         memberAnswers.find((q) => q.key === key && q.index === index)?.answer ||
//         ''
//       );
//     }
//     return memberAnswers.find((q) => q.key === key)?.answer || '';
//   };  
const getAnswer = (memberKey, index, key, member) => {
  if (memberKey === 'child') {
    const childAnswers = member?.proposalMedicalQuestion || [];
    return childAnswers.find((q) => q.key === key)?.answer || '';
  }

  const memberAnswers = values?.proposalMedicalQuestion?.[memberKey] || [];
  return memberAnswers.find((q) => q.key === key)?.answer || '';
};


  const renderMemberSection = (member, index, memberKey) => {
    const relation = member.relation?.toLowerCase?.();
    const memberTitle =
      member.relation?.charAt(0).toUpperCase() + member.relation?.slice(1) ||
      'Member';

    return (
      <Section key={`${memberKey}_${index ?? ''}`}>
        <Title>{memberTitle}</Title>
        <SubTitle>Medical History</SubTitle>

        {questions.map((question) => (
          <QuestionBlock key={`${memberKey}_${index ?? ''}_${question.key}`}>
            <Label>{question.text}</Label>
            <RadioGroup>
              <label>
                <input
                  type="radio"
                  name={`${memberKey}_${index ?? ''}_${question.key}`}
                  value="Yes"
                  checked={
                    getAnswer(memberKey, index, question.key, relation) ===
                    'Yes'
                  }
                  onChange={handleChange(memberKey, index, question, relation)}
                />{' '}
                Yes
              </label>
              <label>
                <input
                  type="radio"
                  name={`${memberKey}_${index ?? ''}_${question.key}`}
                  value="No"
                  checked={
                    getAnswer(memberKey, index, question.key, relation) === 'No'
                  }
                  onChange={handleChange(memberKey, index, question, relation)}
                />{' '}
                No
              </label>
            </RadioGroup>
          </QuestionBlock>
        ))}
      </Section>
    );
  };

  return (
    <>
      {insuredMembers.self &&
        renderMemberSection(insuredMembers.self, null, 'self')}

      {insuredMembers.spouse &&
        renderMemberSection(insuredMembers.spouse, null, 'spouse')}

      {insuredMembers.parent &&
        renderMemberSection(insuredMembers.parent, null, 'parent')}

      {insuredMembers.inLaws &&
        renderMemberSection(insuredMembers.inLaws, null, 'inLaws')}

      {Array.isArray(insuredMembers.child) &&
        insuredMembers.child.map((child, index) =>
          renderMemberSection(child, index, 'child')
        )}

      <div style={{ marginTop: '20px' }}>
        <ButtonBack onClick={onBack}>Back</ButtonBack>
        <ButtonSubmit onClick={onContinue}>Submit</ButtonSubmit>
      </div>
    </>
  );
};

export default MedicalHistory;
